import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { TabItem } from '../../../components'

const ContentNav = ({organization, route, className, mobile}) => {
  const history = useHistory()
  const [selected, setSelected] = React.useState('About')
  const routes = [
    'Tentang',
    'Inisiatif',
    // 'Program',
    'Produk',
    'Event',
    'Blog'
  ]

  useEffect(() => {
    if (route) setSelected(route)
  }, [route])

  const handleClick = (routeName) => {
    setSelected(routeName)
    const route = routeName.toLowerCase()
    if(organization && organization.id){
      history.push(`/organization/${organization.id}/detail/${route}`)
    }
  }

  return (
    <div className={`flex overflow-x-auto border-b ${className}`}>
      {
        routes.map((r, index) => (
          <TabItem
            key={index}
            selected={selected}
            onClick={() => handleClick(r)}
            text={r}
            className={mobile ? `py-3 px-5 text-center` : `pb-4 mr-12`}
            accent
            uppercase
          />
        ))
      }
    </div>
  )
}

export { ContentNav }